enum InputFeedbackFocus {
    Correct = 'Correct',
    Incorrect = 'Incorrect',
    None = 'None',
}

export default InputFeedbackFocus;
